import IMask from 'imask';
import validade from 'jquery-validation';
validade;

const form = $('#contact-form');
const name = document.querySelector('#contact-form #name');
const btnSubmit = $(form).find('button[type=submit]');
const errorView = document.querySelector('.contactError');
const successView = document.querySelector('.contactSuccess');

name.addEventListener('focus', () => {
    window.loadRecaptchaV3();
});

$(form).validate({
    rules: {
        name: {
            required: true,
        },
        email: {
            required: true,
            email: true,
        },
        phone: {
            required: true,
        },
        subject: {
            required: true,
        },
        message: {
            required: true,
        },
        terms: {
            required: true,
        },
    },
    errorPlacement: function (error, element) {
        errorView.scrollIntoView({ behavior: 'smooth' });
    },
    submitHandler: function (form, event) {
        event.preventDefault();
        event.stopPropagation();

        reloadCaptcha('contact', 'g-recaptcha-response', function () {
            $.ajax({
                type: 'POST',
                url: $(form).data('action'),
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (data) {
                    form.reset();
                    $(form).find('.contactError').addClass('hidden');
                    $(form).find('.contactSuccess').removeClass('hidden');
                    successView.scrollIntoView({ behavior: 'smooth' });
                },
                error: function (data) {
                    $(form).find('.contactError').removeClass('hidden');
                    $(form).find('.contactSuccess').addClass('hidden');
                    errorView.scrollIntoView({ behavior: 'smooth' });
                },
            });
        });
    },
});

new IMask(document.querySelector('.phoneMask'), {
    mask: [
        {
            mask: '(00) 0000-0000',
        },
        {
            mask: '(00) 00000-0000',
        },
    ],
});
